export default __webpack_public_path__ + "static/media/8.5e63a86f.jpg";